export default "__VITE_ASSET__CLnDr9Q3__"